import { XeroFinancialSyncData } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";

export const getOmniLinkUrl = (
  data: Pick<XeroFinancialSyncData, "sourceEntityId" | "operationType">
): string | undefined => {
  const { sourceEntityId, operationType } = data;
  if (!sourceEntityId) return undefined;

  if (
    operationType === "XERO.BANKTRANSACTION.CREATE" ||
    operationType === "XERO.BANKTRANSACTION.UPDATE" ||
    operationType === "XERO.BATCHPAYMENT.CREATE" ||
    operationType === "XERO.BATCHPAYMENT.DELETE"
  ) {
    return routes.accounts.payments.viewPath.path({ id: sourceEntityId });
  }

  if (
    operationType === "XERO.CONTACT.CREATE" ||
    operationType === "XERO.CONTACT.UPDATE"
  ) {
    return routes.contacts.contact.path({ id: sourceEntityId });
  }

  if (
    operationType === "XERO.INVOICE.CREATE" ||
    operationType === "XERO.INVOICE.UPDATE"
  ) {
    return routes.accounts.invoices.invoice.path({ id: sourceEntityId });
  }

  return undefined;
};

export const getXeroLinkUrl = (
  data: Pick<XeroFinancialSyncData, "targetId" | "operationType">
) => {
  const { targetId, operationType } = data;
  if (!targetId) return undefined;

  if (
    operationType === "XERO.BANKTRANSACTION.CREATE" ||
    operationType === "XERO.BANKTRANSACTION.UPDATE" ||
    operationType === "XERO.BATCHPAYMENT.CREATE" ||
    operationType === "XERO.BATCHPAYMENT.DELETE"
  ) {
    return `https://go.xero.com/Bank/ViewTransaction.aspx?bankTransactionID=${targetId}`;
  }

  if (
    operationType === "XERO.CONTACT.CREATE" ||
    operationType === "XERO.CONTACT.UPDATE"
  ) {
    return `https://go.xero.com/app/contacts/contact/${targetId}`;
  }

  if (
    operationType === "XERO.INVOICE.CREATE" ||
    operationType === "XERO.INVOICE.UPDATE"
  ) {
    return `https://go.xero.com/app/invoicing/view/${targetId}`;
  }

  return undefined;
};
